import { NextSeo } from "next-seo"
import Footer from "../components/footer"
import Menu from "../components/menu"
import Link from "next/link"
import database from "../database.mjs"
import { useRef, useState } from "react"

export async function getServerSideProps(context) {
  const headers = context.req.headers

  const isUK = headers?.["cloudfront-viewer-country"] === "GB"

  const row = database.prepare("select count(1) from properties_for_sale").get()
  const count = row?.["count(1)"]

  const facebook = database
    .prepare("select value from socials where platform = 'facebook-new' order by timestamp desc limit 1")
    .get()

  const instagram = database
    .prepare("select value from socials where platform = 'instagram' order by timestamp desc limit 1")
    .get()

  const tiktok = database
    .prepare("select value from socials where platform = 'tiktok-new' order by timestamp desc limit 1")
    .get()

  return {
    props: {
      saleCount: count,
      socials: {
        facebook: facebook?.value || null,
        tiktok: tiktok?.value || null,
        instagram: instagram?.value || null,
      },
      isUK,
    },
  }
}

let a = ["a", "n", "d", "r", "e", "w", "@", "h", "u", "n", "t", "l", "e", "y", "s", ".", "n", "e", "t"]
let k = ["k", "y", "f", "e", "r", "@", "h", "u", "n", "t", "l", "e", "y", "s", ".", "n", "e", "t"]

const Press = ({ saleCount, socials, isUK }) => {
  const [index, setIndex] = useState(0)

  const carouselRef = useRef()

  return (
    <>
      <NextSeo
        title="Press Kit"
        description="When it comes to estate and letting agents in Loughborough, Huntleys stands out as an exceptional and reputable company. With a commitment to excellence and a track record of success, Huntleys has established itself as a leading player in the local real estate market. Through our innovative approach and dedication to customer satisfaction, we continue to set new standards in the industry."
      />
      <div className="h-[62.5vh] bg-cpink relative">
        <img className="object-cover object-top w-full h-full select-none" src="/images/team-2.webp" alt="Loughborough" />
        <div className="absolute p-4 top-0 bottom-0 left-0 right-0 flex items-center justify-center bg-[rgba(0,0,0,.25)]">
          <div className="text-center">
            <h1 className="font-serif text-5xl font-semibold leading-tight text-center text-white md:text-6xl drop-shadow-xl">
              Press Kit
            </h1>
          </div>
        </div>
      </div>

      <div className="flex items-center justify-center max-w-[100vw] overflow-hidden">
        <div className="flex items-center justify-center px-4 py-6 md:py-8">
          <div className="flex flex-col items-center justify-center gap-0 mx-auto md:gap-6 sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl text-stone-900">
            <div className="text-[15px] leading-[1.5] mt-10 text-justify text-stone-800 font-light flex flex-col gap-6 md:gap-8 blog-post">
              {/* <p>
                Huntleys is a single-office, independent, Estate and Letting agency based in Loughborough, covering Charnwood
                and the surrounding area. Our engaging home tours, and innovative marketing, have made us Charnwood’s most
                followed Agent.
              </p> */}
              <p>
                Huntleys are letting specialists based in Loughborough who let out more professional property in Charnwood than
                any other agency. Due to increasing demand, we will open a second branch in West Bridgford, enhancing our
                ability to serve the area effectively. Reach out to us for prompt and informed market commentary.
              </p>
              <div className="w-full px-4 mx-auto mt-2 no-underline">
                <div className="grid max-w-screen-sm gap-8 mx-auto sm:grid-cols-2">
                  <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">OPENED</h1>
                    <p className="mt-1 text-4xl">Jan 2017</p>
                  </div>
                  {/* <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">LAUNCHED SALES</h1>
                    <p className="mt-1 text-4xl">Oct 2022</p>
                  </div> */}
                  <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">PROPERTIES MANAGED</h1>
                    <p className="mt-1 text-4xl">480+</p>
                  </div>
                  {/* <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">PROPERTIES FOR SALE</h1>
                    <p className="mt-1 text-4xl">{saleCount}</p>
                  </div> */}
                  <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">NUMBER OF EMPLOYEES</h1>
                    <p className="mt-1 text-4xl">7</p>
                  </div>
                  {Number(socials?.facebook) >= 1000 && (
                    <div>
                      <h1 className="text-sm font-medium tracking-wide text-stone-500">FACEBOOK FOLLOWERS</h1>
                      <p className="mt-1 text-4xl">{Number(socials.facebook).toLocaleString()}</p>
                    </div>
                  )}
                  {/* {Number(socials?.tiktok) >= 1000 && (
                    <div>
                      <h1 className="text-sm font-medium tracking-wide text-stone-500">TIKTOK FOLLOWERS</h1>
                      <p className="mt-1 text-4xl">{Number(socials.tiktok).toLocaleString()}</p>
                    </div>
                  )} */}
                  <div>
                    <h1 className="text-sm font-medium tracking-wide text-stone-500">INSTAGRAM FOLLOWERS</h1>
                    <p className="mt-1 text-4xl">{Number(socials.instagram).toLocaleString()}</p>
                  </div>
                </div>
                <div className="text-[15px]">
                  <p className="mt-8" style={{ fontSize: 15 }}>
                    For press enquiries:
                  </p>
                  <div className="flex w-full max-w-screen-sm overflow-hidden">
                    <div className="w-full max-w-screen-sm grid-cols-2 gap-6 mt-4 md:grid">
                      {/* {isUK && (
                        <div className="block overflow-hidden">
                          <div
                            className="flex items-center gap-3 p-3 mt-4 no-underline transition-all duration-300 rounded cursor-pointer md:mt-0 bg-cpink hover:bg-cpink-50"
                            onClick={() => {
                              window.open(`mailto:${r.join("")}`)
                            }}
                          >
                            <div>
                              <div className="w-16 h-16 overflow-hidden rounded-full select-none">
                                <img
                                  alt="Rebecca Holders, Managing Director of Sales at Huntleys Estate Agents"
                                  className="object-cover"
                                  src="/images/rebecca.webp"
                                />
                              </div>
                            </div>
                            <div>
                              <p className="font-medium tracking-wide" style={{ fontSize: 9 }}>
                                SALES COMMENTARY
                              </p>
                              <h2 className="font-medium">Rebecca Holders</h2>
                              <img alt="Rebecca Holders" className="block h-[14px] mt-1 select-none" src="/images/xyz.png" />
                            </div>
                          </div>
                        </div>
                      )} */}
                      <div className="block overflow-hidden">
                        <div
                          className="flex items-center gap-3 p-3 mt-4 no-underline transition-all duration-300 rounded cursor-pointer md:mt-0 bg-cpink hover:bg-cpink-50"
                          onClick={() => {
                            window.open(`mailto:${k.join("")}`)
                          }}
                        >
                          <div>
                            <div className="w-16 h-16 overflow-hidden rounded-full select-none">
                              <img
                                alt="Kyfer Leech, Lettings Valuer at Huntleys Estate Agents"
                                className="object-cover"
                                src="/images/kyfer.webp"
                              />
                            </div>
                          </div>
                          <div>
                            <p className="font-medium tracking-wide" style={{ fontSize: 9 }}>
                              LETTINGS COMMENTARY
                            </p>
                            <h2 className="font-medium">Kyfer Leech</h2>
                            <img alt="Kyfer Leech" className="block h-[14px] mt-1 select-none" src="/images/lmn.png" />
                          </div>
                        </div>
                      </div>
                      <div className="block mt-4 overflow-hidden md:mt-0">
                        <div
                          className="flex items-center gap-3 p-3 no-underline transition-all duration-300 rounded cursor-pointer bg-cpink hover:bg-cpink-50"
                          onClick={() => {
                            window.open(`mailto:${a.join("")}`)
                          }}
                        >
                          <div>
                            <div className="w-16 h-16 overflow-hidden rounded-full select-none">
                              <img
                                alt="Andrew Huntley, Director at Huntleys Estate Agents"
                                className="object-cover"
                                src="/images/andrew.webp"
                              />
                            </div>
                          </div>
                          <div>
                            <p className="font-medium tracking-wide" style={{ fontSize: 9 }}>
                              BRAND COMMENTARY
                            </p>
                            <h2 className="font-medium">Andrew Huntley</h2>
                            <img alt="Andrew Huntley" className="block h-[14px] mt-1 select-none" src="/images/abc.png" />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative max-w-screen-sm mx-auto mt-8 border-stone-900">
                  <h2 className="font-serif text-2xl font-semibold">Brand Assets</h2>
                  <div className="relative mt-8">
                    <div
                      ref={carouselRef}
                      className="relative flex w-full h-full overflow-hidden overflow-x-scroll rounded select-none bg-cpink snap-mandatory snap-x aspect-video no-scrollbar"
                      onScroll={e => {
                        setIndex(Math.round(e.target.scrollLeft / e.target.clientWidth))
                      }}
                    >
                      {[...Array(13)].map((_, index) => (
                        <img
                          key={index}
                          className="object-contain min-w-full overflow-hidden rounded aspect-video snap-center"
                          src={`/press-kit/${index + 1}.jpg`}
                          loading="lazy"
                        />
                      ))}
                    </div>
                    <div className="absolute right-0 flex justify-start gap-2 bottom-4 left-4">
                      <div className="block">
                        <a
                          download
                          href={`/press-kit/${index + 1}.jpg`}
                          className={`p-2 px-3 inline-flex text-xs items-center no-underline justify-center gap-1 duration-300 bg-white border rounded-full hover:cursor-pointer drop-shadow ${
                            false ? "text-stone-400 border-stone-400" : "cursor-pointer text-stone-900 border-stone-900 "
                          }`}
                        >
                          <div className="flex items-center gap-1">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              fill="none"
                              viewBox="0 0 24 24"
                              strokeWidth={1.5}
                              stroke="currentColor"
                              className="block w-3 h-3"
                            >
                              <path
                                strokeLinecap="round"
                                strokeLinejoin="round"
                                d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12L12 16.5m0 0L7.5 12m4.5 4.5V3"
                              />
                            </svg>
                            {index + 1}.jpg
                          </div>
                        </a>
                      </div>
                      <a
                        download
                        href={`/press-kit.zip`}
                        className={`p-2 px-3 inline-flex text-xs items-center no-underline justify-center gap-1 duration-300 bg-white border rounded-full hover:cursor-pointer drop-shadow ${
                          false ? "text-stone-400 border-stone-400" : "cursor-pointer text-stone-900 border-stone-900 "
                        }`}
                      >
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          fill="none"
                          viewBox="0 0 24 24"
                          strokeWidth={1.5}
                          stroke="currentColor"
                          className="w-4 h-4"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            d="M9 13.5l3 3m0 0l3-3m-3 3v-6m1.06-4.19l-2.12-2.12a1.5 1.5 0 00-1.061-.44H4.5A2.25 2.25 0 002.25 6v12a2.25 2.25 0 002.25 2.25h15A2.25 2.25 0 0021.75 18V9a2.25 2.25 0 00-2.25-2.25h-5.379a1.5 1.5 0 01-1.06-.44z"
                          />
                        </svg>
                        press-kit.zip
                      </a>
                    </div>
                    <div className="absolute top-0 bottom-0 flex items-center pointer-events-none left-4">
                      <button
                        onClick={() => {
                          const idx = Math.max(0, index - 1)
                          setIndex(idx)
                          carouselRef.current.scrollLeft = carouselRef.current.clientWidth * idx
                        }}
                        className={`block p-2 transition-all duration-300 bg-white border rounded-full pointer-events-auto drop-shadow ${
                          index === 0
                            ? "cursor-not-allowed text-stone-400 border-stone-400"
                            : "cursor-pointer text-stone-900 border-stone-900 "
                        }`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path
                            fillRule="evenodd"
                            d="M11.03 3.97a.75.75 0 010 1.06l-6.22 6.22H21a.75.75 0 010 1.5H4.81l6.22 6.22a.75.75 0 11-1.06 1.06l-7.5-7.5a.75.75 0 010-1.06l7.5-7.5a.75.75 0 011.06 0z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                    <div className="absolute top-0 bottom-0 flex items-center right-4">
                      <button
                        onClick={() => {
                          const idx = Math.min(12, index + 1)
                          setIndex(idx)
                          carouselRef.current.scrollLeft = carouselRef.current.clientWidth * idx
                        }}
                        className={`block p-2 transition-all duration-300 bg-white border rounded-full pointer-events-auto drop-shadow ${
                          index === 20
                            ? "cursor-not-allowed text-stone-400 border-stone-400"
                            : "cursor-pointer text-stone-900 border-stone-900 "
                        }`}
                      >
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="w-5 h-5">
                          <path
                            fillRule="evenodd"
                            d="M12.97 3.97a.75.75 0 011.06 0l7.5 7.5a.75.75 0 010 1.06l-7.5 7.5a.75.75 0 11-1.06-1.06l6.22-6.22H3a.75.75 0 010-1.5h16.19l-6.22-6.22a.75.75 0 010-1.06z"
                            clipRule="evenodd"
                          />
                        </svg>
                      </button>
                    </div>
                  </div>
                </div>
                <div className="max-w-screen-sm mx-auto mt-8 border-stone-900">
                  <div className="flex flex-col gap-4 mt-6 overflow-hidden rounded md:gap-3 md:flex-row bg-cpink">
                    <div className="flex-1 h-full rounded">
                      <div className="p-6 pb-0">
                        <img alt="Huntleys logo white" className="object-contain h-10 mx-auto" src="/huntleys-white.svg" />
                      </div>
                      <div className="flex gap-4 p-4">
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-white.svg"
                          download
                        >
                          SVG
                        </a>
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-white.png"
                          download
                        >
                          PNG
                        </a>
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-white.jpg"
                          download
                        >
                          JPEG
                        </a>
                      </div>
                    </div>
                    <div className="hidden w-px py-4 md:block">
                      <div className="w-full h-full bg-stone-900"></div>
                    </div>
                    <div className="px-4 md:hidden">
                      <div className="w-full h-px bg-stone-900"></div>
                    </div>
                    <div className="flex-1 h-full rounded">
                      <div className="p-6 pb-0">
                        <img
                          alt="Huntleys logo charcoal"
                          className="object-contain h-10 mx-auto"
                          src="/huntleys-charcoal.svg"
                        />
                      </div>
                      <div className="flex gap-4 p-4">
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-charcoal.svg"
                          download
                        >
                          SVG
                        </a>
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-charcoal.png"
                          download
                        >
                          PNG
                        </a>
                        <a
                          className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                          href="/huntleys-charcoal.jpg"
                          download
                        >
                          JPEG
                        </a>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col w-full gap-4 mt-8">
                    <div className="flex-1 p-4 font-medium tracking-wider text-left text-white bg-teal-900 rounded sm:flex">
                      <div className="flex-1">
                        <p className="text-xs text-white">#134E4A (19, 78, 74)</p>
                        <p className="mt-1 tracking-normal">Charnwood Green</p>
                      </div>
                    </div>
                    <div className="flex-1 p-4 font-medium tracking-wider text-left rounded text-stone-900 bg-cpink">
                      <div>
                        <p className="text-xs text-stone-900">#E0C5B3 (224, 197, 179)</p>
                        <p className="mt-1 tracking-normal">Quarry Stone</p>
                      </div>
                    </div>
                    <div className="flex-1 p-4 font-medium tracking-wider text-left text-white rounded bg-stone-900">
                      <div>
                        <p className="text-xs text-stone-50">#1C1719 (28, 23, 25)</p>
                        <p className="mt-1 tracking-normal">Charcoal</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="flex items-center justify-center w-full">
        <div className="flex items-center w-full sm:max-w-screen-sm md:max-w-screen-md lg:max-w-screen-lg xl:max-w-screen-xl 2xl:max-w-screen-2xl">
          <div className="flex px-4 py-12">
            <div className="text-stone-900">
              <div className="flex flex-col gap-x-12 lg:flex-row">
                <div>
                  <h2 className="font-serif text-2xl font-semibold">Huntleys Estate & Letting Agents in Loughborough</h2>
                  <div className="text-[15px] leading-[1.5] text-justify text-stone-800 font-light">
                    <p className="mt-6">
                      When it comes to estate and letting agents in Loughborough, Huntleys tands out as an exceptional and
                      reputable company. With a commitment to excellence and a track record of success, Huntleys has established
                      itself as a leading player in the local real estate market. Through our innovative approach and dedication
                      to customer satisfaction, we continue to set new standards in the industry.
                    </p>
                    <p className="mt-4">
                      One of the key reasons why we're widely regarded as an excellent choice is our unwavering focus on
                      delivering exceptional service. The Huntleys team understands that buying, selling, or renting a property
                      is a significant decision for our clients. Therefore, we strive to provide personalized attention, expert
                      advice, and a seamless experience throughout the entire process.
                    </p>
                    <p className="mt-4">
                      We recognise that the real estate industry is constantly evolving, and we are at the forefront of
                      innovation. By leveraging the latest technologies and industry trends, we continuously seek to improve our
                      services and enhance the overall customer experience. We embrace cutting-edge tools to present properties
                      in the most captivating and informative manner.
                    </p>
                    <p className="mt-4">
                      In addition to technological advancements, we also takes pride in our marketing strategies. We understand
                      that effective marketing is crucial in attracting the right buyers and tenants. With a comprehensive
                      approach that includes online platforms, social media campaigns, targeted advertising, and traditional
                      marketing methods, we ensure maximum exposure for our clients' properties.
                    </p>
                  </div>
                  <div className="py-10 mt-8 border-t border-b border-stone-900">
                    <h2 className="font-serif text-2xl font-semibold">Brand Assets</h2>
                    <p className="mt-4">Our brand assets are available for download below in various formats.</p>
                    <div className="flex flex-col gap-4 mt-6 md:gap-8 md:flex-row">
                      <div className="flex-1 h-full rounded bg-stone-900">
                        <div className="p-6 pb-0">
                          <img className="object-contain h-10 mx-auto" src="/huntleys-white.svg" />
                        </div>
                        <div className="flex gap-4 p-4">
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-white.svg"
                            download
                          >
                            SVG
                          </Link>
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-white.png"
                            download
                          >
                            PNG
                          </Link>
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-white.jpg"
                            download
                          >
                            JPEG
                          </Link>
                        </div>
                      </div>
                      <div className="flex-1 h-full rounded bg-cpink-200">
                        <div className="p-6 pb-0">
                          <img className="object-contain h-10 mx-auto" src="/huntleys-charcoal.svg" />
                        </div>
                        <div className="flex gap-4 p-4">
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-charcoal.svg"
                            download
                          >
                            SVG
                          </Link>
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-charcoal.png"
                            download
                          >
                            PNG
                          </Link>
                          <Link
                            className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                            href="/huntleys-charcoal.jpg"
                            download
                          >
                            JPEG
                          </Link>
                        </div>
                      </div>
                    </div>
                    <div className="flex flex-col gap-4 mt-8 md:flex-row">
                      <div className="flex-1 p-4 font-medium tracking-wider text-left text-white bg-teal-900 rounded">
                        <div>
                          <p className="text-xs text-teal-50">#134E4A</p>
                          <p className="mt-1 tracking-normal">Huntleys Teal</p>
                        </div>
                      </div>
                      <div className="flex-1 p-4 font-medium tracking-wider text-left rounded text-stone-900 bg-cpink">
                        <div>
                          <p className="text-xs text-stone-900">#E0C5B3</p>
                          <p className="mt-1 tracking-normal">Huntleys Champagne Pink</p>
                        </div>
                      </div>
                      <div className="flex-1 p-4 font-medium tracking-wider text-left text-white rounded bg-stone-900">
                        <div>
                          <p className="text-xs text-stone-50">#1C1719</p>
                          <p className="mt-1 tracking-normal">Huntleys Charcoal</p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="flex flex-col justify-between gap-6 mt-8 md:gap-10 xl:flex-row">
                    <div className={[`relative flex w-full mx-auto flex-1 rounded aspect-video`].join(" ")}>
                      <div className="w-full h-full overflow-hidden rounded">
                        <div className="absolute top-0 left-0 right-0 h-24 rounded-t opacity-75 bg-gradient-to-b from-stone-900 to-transparent"></div>
                        <p className="absolute text-white drop-shadow-md top-8 left-6 lg:top-8 lg:left-8">Sell with Huntleys</p>
                        <div className="absolute bottom-0 left-0 right-0 h-32 rounded-b opacity-75 bg-gradient-to-t from-stone-900 to-transparent"></div>
                        <div className="absolute left-8 bottom-6 lg:bottom-8 lg:left-8">
                          <h1 className="font-serif text-2xl font-medium text-white sm:text-3xl drop-shadow lg:text-4xl">
                            Rebecca Holders
                          </h1>
                          <p className="text-white drop-shadow-md">Sales Managing Director</p>
                        </div>
                        <div className="absolute top-0 bottom-0 left-0 right-0 flex">
                          <button
                            className={[
                              `flex p-4 m-auto text-white transition-all duration-300 border-2 border-white rounded-full hover:text-teal-900 hover:bg-white md:p-6 xl:p-4 drop-shadow md:border-4`,
                            ].join(" ")}
                            onClick={() => {
                              document.body.classList.add("overflow-hidden")
                              setIsVideoOpen(true)
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="w-5 h-5 m-auto md:h-6 md:w-6"
                            >
                              <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                            </svg>
                          </button>
                        </div>
                        <img className="object-cover w-full h-full rounded select-none" src="/images/sales-thumbnail.jpg" />
                      </div>
                    </div>
                    <div className={[`relative flex w-full mx-auto flex-1 rounded aspect-video`].join(" ")}>
                      <div className="w-full h-full overflow-hidden rounded">
                        <div className="absolute top-0 left-0 right-0 h-24 rounded-t opacity-75 bg-gradient-to-b from-stone-900 to-transparent"></div>
                        <p className="absolute text-white drop-shadow-md top-8 left-6 lg:top-8 lg:left-8">Let with Huntleys</p>
                        <div className="absolute bottom-0 left-0 right-0 h-32 rounded-b opacity-75 bg-gradient-to-t from-stone-900 to-transparent"></div>
                        <div className="absolute left-8 bottom-6 lg:bottom-8 lg:left-8">
                          <h1 className="font-serif text-2xl font-medium text-white sm:text-3xl drop-shadow lg:text-4xl">
                            Kyfer Leech
                          </h1>
                          <p className="text-white drop-shadow-md">Lettings Valuer</p>
                        </div>
                        <div className="absolute top-0 bottom-0 left-0 right-0 flex">
                          <button
                            className={[
                              `flex p-4 m-auto text-white transition-all duration-300 border-2 border-white rounded-full hover:text-teal-900 hover:bg-white md:p-6 xl:p-4 drop-shadow md:border-4`,
                            ].join(" ")}
                            onClick={() => {
                              document.body.classList.add("overflow-hidden")
                              setIsVideoOpen(true)
                            }}
                          >
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 20 20"
                              fill="currentColor"
                              className="w-5 h-5 m-auto md:h-6 md:w-6"
                            >
                              <path d="M6.3 2.841A1.5 1.5 0 004 4.11V15.89a1.5 1.5 0 002.3 1.269l9.344-5.89a1.5 1.5 0 000-2.538L6.3 2.84z" />
                            </svg>
                          </button>
                        </div>
                        <img className="object-cover w-full h-full rounded select-none" src="/images/let-thumbnail.webp" />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="text-[15px] mt-5 flex flex-col w-full lg:mt-0 lg:max-w-xs text-stone-800 min-w-[20rem]">
                  <div className="flex flex-col w-full mt-5 lg:max-w-xs gap-y-3">
                    <Link
                      className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                      href="/contact"
                    >
                      Contact Us
                    </Link>
                    <Link
                      className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                      href="/articles"
                    >
                      Articles
                    </Link>
                    <Link
                      className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                      href="/sell"
                    >
                      Sales
                    </Link>
                    <Link
                      className="flex items-center justify-center flex-1 p-3 font-medium text-center no-underline transition-all duration-300 border rounded hover:bg-white bg-cpink-200 border-cpink-200 hover:text-stone-900 hover:border-white text-stone-900"
                      href="/landlords"
                    >
                      Lettings
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
      <section className="px-4 py-6 bg-cpink">
        <p className="max-w-screen-sm mx-auto text-stone-900 text-[15px]">
          These resources exist to help you use our brand and other assets, including our logo, content, and screenshots, for
          your next article. They are free to use for press and media referencing “huntleys.net” or “Huntleys of Loughborough”.
          To use these assets in any other way, please contact us via{" "}
          <Link
            href="#"
            className="relative inline-block ml-1 -mr-1 underline"
            onClick={() => {
              window.open(`mailto:${a.join("")}`)
            }}
          >
            <img alt="text" className="h-[15px] block opacity-0" src="/images/abc.png" />
            <img
              alt="text"
              className="h-[15px] block absolute top-0.5 left-0 right-0 border-b border-stone-900"
              src="/images/abc.png"
            />
          </Link>
          and include a visual mock-up of the intended use.
        </p>
      </section>
      <Footer />
      <Menu />
    </>
  )
}

export default Press

